import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';

// Configure dayjs
dayjs.extend(utc);
dayjs.extend(timezonePlugin);

/**
 * Formats a date with the specified timezone and hour
 * @param date The date to format
 * @param hour The hour to set (0-23)
 * @param timezoneId The timezone ID (e.g., 'America/New_York')
 * @returns Formatted date string in ISO format with timezone offset
 */
export const formatDateWithTimezone = (date: Date, hour: number, timezoneId: string): string => {
  if (!date) return dayjs().tz(timezoneId).format('YYYY-MM-DDTHH:mm:ssZ');
  // Create a dayjs object with the selected date in the selected timezone
  // .tz second argument to true to keep local time
  const localTime = dayjs(date).tz(timezoneId, true).hour(hour).minute(0).second(0).millisecond(0);
  // Format with timezone offset (e.g., +08:00 for Singapore)
  return localTime.format('YYYY-MM-DDTHH:mm:ssZ');
};
